import { createDraftSafeSelector } from '@reduxjs/toolkit';

import type { RootState } from 'App/Store';

const getRoot = (state: RootState) => state;
const getState = createDraftSafeSelector(getRoot, (state) => state.onlinePayment);

export const isPayingModalOpen = createDraftSafeSelector(getState, (state) => state.isPayingModalOpen);
export const getStatus = createDraftSafeSelector(getState, (state) => state.status);
